import { Mark, mergeAttributes } from '@tiptap/core';

export interface HtmlSpanOptions {
    HTMLAttributes: Record<string, any>;
}

const HtmlSpan = Mark.create<HtmlSpanOptions>({
    name: 'htmlSpan',

    addOptions() {
        return {
            HTMLAttributes: {},
        };
    },

    parseHTML() {
        return [
            {
                tag: 'span',
            },
        ];
    },

    renderHTML({ HTMLAttributes }) {
        return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes), 0];
    },
});

export { HtmlSpan };
